export const renderMinErrorMessage =
	(translate: (key: string) => string) =>
	({ min }: { min: number }) => {
		return min <= 1 ? `${translate("must-be-positive-number")} ${min}` : `${translate("min-is")} ${min}`;
	};
